import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiFetch } from "../../../utils";

export const fetchAllPackages = createAsyncThunk(
    "admin/fetchAllPackages",
    async () => {
        const response = await apiFetch("api/a/packages");
        return await response.json();
    }
)

export const fetchResourceTemplates = createAsyncThunk(
    "admin/fetchResources",
    async () => {
        const res = await apiFetch("api/a/templates");
        return await res.json();
    }
)

export const createPackage = createAsyncThunk(
    "admin/createPackage",
    async (payload) => {
        const res = await apiFetch("api/a/package", {
            method: "POST",
            body: JSON.stringify(payload)
        });
        return await res.json();
    }
)

export const updatePackage = createAsyncThunk(
    "admin/updatePackage",
    async ({ packageId, payload }) => {
        const res = await apiFetch(`api/a/package/${packageId}`, {
            method: "PUT",
            body: JSON.stringify(payload)
        });
        return await res.json();
    }
)

export const deletePackage = createAsyncThunk(
    "admin/deletePackage",
    async (packageId) => {
        const res = await apiFetch(`api/a/package/${packageId}`, {
            method: "DELETE",
        });

        return await res.json();
    }
)

const packageSlice = createSlice({
    name: "adminPackage",
    initialState: {
        packages: [],
        resources: [],
        configs: [],
        snapshots: [],
        providers: [],
        regions:[],
        sizes: [],
        loading: true,
        error: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllPackages.pending, (state) => {
                state.loading = true;
                state.packages = [];
                state.resources = [];
                state.configs = [];
            })
            .addCase(fetchAllPackages.fulfilled, (state, action) => {
                state.loading = false;
                state.packages = action.payload.packages
                state.resources = action.payload.resources
                state.configs = action.payload.configs
            })
            .addCase(fetchAllPackages.rejected, (state) => {
                state.loading = false;
                state.error = true;
            })
            .addCase(updatePackage.pending, (state) => {
                state.loading = true;
            })
            .addCase(updatePackage.fulfilled, (state, action) => {
                const updatedPackage = action.payload.package;

                var index = state.packages.findIndex(
                    p => p.id === updatedPackage.id
                );

                if (index !== -1) {
                    state.packages[index] = updatedPackage; // replace
                } else {
                    state.packages.push(updatedPackage); // fallback (optional)
                }

                const updateResource = action.payload.resources;
                index = state.resources.findIndex(p => p.id === updateResource.id);

                if (index !== -1) {
                    state.resources[index] = updateResource; // replace
                } else {
                    state.resources.push(updateResource); // fallback (optional)
                }
                
                state.loading = false;
            })
            .addCase(updatePackage.rejected, (state) => {
                state.loading = false;
                state.error = true;
            })
            .addCase(createPackage.pending, (state) => {
                state.loading = true;
            })
            .addCase(createPackage.fulfilled, (state, action) => {
                state.packages.push(action.payload.packages);
                state.resources.push(action.payload.resources);
                state.loading = false;
                state.error = false;
            })
            .addCase(createPackage.rejected, (state) => {
                state.loading = false;
                state.error = true;
            })
            .addCase(fetchResourceTemplates.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchResourceTemplates.fulfilled, (state, action) => {
                state.loading = false;
                state.snapshots = action.payload.snapshots;
                state.regions = action.payload.regions;
                state.providers = action.payload.providers;
                state.sizes = action.payload.sizes;
            })
            .addCase(fetchResourceTemplates.rejected, (state) => {
                state.loading = false;
                state.error = true;
            });
    }
});

export default packageSlice.reducer;
